// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1p3Td","content":"GlobalSearch_content__3Ub24"};